(function () {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  function setCardImage(cardEl, newUrl) {
    if (!cardEl || !newUrl) return;

    const img = cardEl.querySelector('.card__media img, .card__inner img, img');
    if (!img) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', newUrl);

    if (img.dataset) {
      if ('src' in img.dataset) img.dataset.src = newUrl;
      if ('master' in img.dataset) img.dataset.master = newUrl;
    }
  }

  ready(() => {
    document.querySelectorAll('[data-card-swatches]').forEach((swatchesEl) => {
      const cardEl = swatchesEl.closest('.card') || swatchesEl.closest('.card-wrapper');
      const wrapperEl = swatchesEl.closest('.card-wrapper') || swatchesEl.closest('.card') || cardEl;

      if (!cardEl) return;

      // ✅ スウォッチに乗ってる間だけ “2枚目ホバー” を止める（画像ホバーは殺さない）
      swatchesEl.addEventListener('pointerenter', () => wrapperEl && wrapperEl.classList.add('swatches-hover'));
      swatchesEl.addEventListener('pointerleave', () => wrapperEl && wrapperEl.classList.remove('swatches-hover'));

      // ✅ クリック：遷移を止めて画像だけ切替
      swatchesEl.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-swatch]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const newUrl = btn.getAttribute('data-image-url');
        setCardImage(cardEl, newUrl);

        swatchesEl.querySelectorAll('[data-swatch].is-active').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      }, true); // ← captureでリンクより先に拾う
    });
  });
})();